import { inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
} from "@angular/router";
import { map } from "rxjs/operators";
import { AuthService } from "./services/auth.service";

function resolveAllowedRoles(route: ActivatedRouteSnapshot): string[] {
  let current: ActivatedRouteSnapshot | null = route;
  while (current) {
    const roles = current.data?.["roles"];
    if (Array.isArray(roles) && roles.length > 0) {
      return roles.map((r) => String(r).trim().toLowerCase()).filter(Boolean);
    }
    current = current.parent;
  }
  return [];
}

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.ensureValidSession().pipe(
    map((sessionOk) => {
      if (!sessionOk) {
        void router.navigate(["/login"], {
          queryParams: { returnUrl: state.url },
        });
        return false;
      }

      const allowedRoles = resolveAllowedRoles(route);
      if (!allowedRoles.length) {
        return true;
      }

      const role = String(authService.getCurrentUser()?.role || "")
        .trim()
        .toLowerCase();
      if (allowedRoles.includes(role)) {
        return true;
      }

      void router.navigate(["/dashboard"]);
      return false;
    }),
  );
};
